// extracted by mini-css-extract-plugin
export var materialIcons = "project-preview-module--material-icons--EEACP";
export var root = "project-preview-module--root--wfIAY";
export var info = "project-preview-module--info--NfDng";
export var title = "project-preview-module--title--04c-s";
export var client = "project-preview-module--client--PgsEy";
export var previewVideo = "project-preview-module--previewVideo--xIHuW";
export var leadMediaThumb = "project-preview-module--leadMediaThumb---5Zp+";
export var excerpt = "project-preview-module--excerpt--chs3A";